import {MenuItem, Slider, TextField, Typography} from "@mui/material"
import {ModalAcceptButton} from "../../../constants/component.constants"
import {ResponsiveRow} from "../../../constants/layout.constants"
import {useEffect, useState} from "react"
import { loadPropertyTypes } from "../../../services/listingsServices/list.service"
import { useNavigate } from "react-router-dom"

export default function ListingSearchWidget() {
    const [locationName, setLocationName] = useState("")
    const [budget, setBudget] = useState({min: 0, max: 10000})
    const [propertyTypes, setPropertyTypes] = useState([])
    const [propertyType, setPropertyType] = useState("")
    const [budgetRange, setBudgetRange] = useState([0, 10000])

    const navigate = useNavigate()

    const handleSearch = () => {
        navigate("/listings/explore", {
            state: {
                locationName: locationName,
                budget: budget,
                propertyType: propertyType
            }
        })
    }

    function handleLocationNameChange (event) {
        setLocationName(event.target.value)
    }

    function handleBudgetSliderChange(event, newValue) {
        setBudgetRange(newValue)
        setBudget({ min: newValue[0], max: newValue[1] })
    }

    function handleMinBudgetInputChange(event) {
        const min = Number(event.target.value)
        setBudgetRange([min, budgetRange[1]])
        setBudget({ min, max: budgetRange[1] })
    }

    function handleMaxBudgetInputChange(event) {
        const max = Number(event.target.value)
        setBudgetRange([budgetRange[0], max])
        setBudget({ min: budgetRange[0], max })
    }

    useEffect(() => {
        loadPropertyTypes()
            .then((data) => setPropertyTypes(data))
            .catch((error) => {
                console.error("loadPropertyTypes Error: ", error)
            })
    }, [])

    return (
        <ResponsiveRow
            sx={{
                flexDirection: "column",
                backgroundColor: "#fff",
                borderRadius: "20px",
                maxHeight: {xs: "auto", lg: "500px"},
                width: {xs: "100%", lg: "80%"},
                padding: 0,
            }}
        >
            <ResponsiveRow
                sx={{
                    alignItems: "center",
                    height: "20%",
                    width: "100%",
                    padding: "10px",
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        padding: "10px",
                        color: "#037171",
                    }}
                >
                    Start your search here:
                </Typography>
            </ResponsiveRow>
            <ResponsiveRow
                sx={{
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    alignItems: {xs: "center", lg: "flex-start"},
                    backgroundColor: "#efefef",
                    borderRadius: "20px",
                    width: "100%",
                    height: "80%",
                    margin: 0,
                    padding: "10px",
                }}
                >
                <TextField
                    variant="outlined"
                    sx={{
                        width: "90%",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        margin: "10px",
                    }}
                    label="Location"
                    value={locationName}
                    onChange={handleLocationNameChange}
                />

                <Typography sx={{ margin: "10px 0 0 10px", fontWeight: 500 }}>
                    Budget Range
                </Typography>
                <ResponsiveRow sx={{ width: "90%", alignItems: "center", margin: "10px" }}>
                    <TextField
                        type="number"
                        label="Min"
                        variant="outlined"
                        size="small"
                        value={budgetRange[0]}
                        onChange={handleMinBudgetInputChange}
                        sx={{ width: "100px", marginRight: "10px", backgroundColor: "#fff", borderRadius: "10px" }}
                        inputProps={{ min: 0, max: budgetRange[1], step: 100 }}
                    />
                    <Slider
                        min={0}
                        max={budgetRange[1] === 1000000 ? 1000000 : budgetRange[1] + 100000}
                        step={100}
                        value={budgetRange}
                        onChange={handleBudgetSliderChange}
                        sx={{
                            flex: 1,
                            margin: "0 10px",
                        }}
                        valueLabelDisplay="auto"
                    />
                    <TextField
                        type="number"
                        label="Max"
                        variant="outlined"
                        size="small"
                        value={budgetRange[1]}
                        onChange={handleMaxBudgetInputChange}
                        sx={{ width: "200px", marginLeft: "10px", backgroundColor: "#fff", borderRadius: "10px" }}
                        inputProps={{ min: budgetRange[0], max: 10000, step: 100 }}
                    />
                </ResponsiveRow>
                <TextField
                    variant="outlined"
                    sx={{
                        width: "90%",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        margin: "10px",
                    }}
                    label="Property Type"
                    select
                    value={propertyType}
                    onChange={e => setPropertyType(e.target.value)}
                >
                    {propertyTypes?.length > 0 
                        ? propertyTypes.map((propertyType, i) => {
                            return (
                                <MenuItem key={i} value={propertyType.value}>{propertyType.label}</MenuItem>
                            )
                        })
                        : <MenuItem value="">None</MenuItem>
                    }
                </TextField>
                <ResponsiveRow
                    sx={{
                        padding: 0,
                        width: "100%",
                        justifyContent: {xs: "center", lg: "flex-end"},
                    }}
                >
                    <ModalAcceptButton
                        sx={{
                            height: "min-content",
                            padding: "10px",
                            width: "200px",
                        }}
                        onClick={handleSearch}
                    >
                        Show Found Listings
                    </ModalAcceptButton>
                </ResponsiveRow>
            </ResponsiveRow>
        </ResponsiveRow>
    )
}
